const SMALL_SIZE = 375;
const MEDIUM_SIZE = 769;

export { SMALL_SIZE, MEDIUM_SIZE };